import styled from "@emotion/styled";
import { TypeRampV2 } from "../../typography";
import { chipTheme } from "./chipTheme";
export const ChipLabelStyled = styled(TypeRampV2)(_ref => {
  let {
    themeMode,
    chipSize,
    fontSize = "",
    fontWeight = "",
    lineHeight = ""
  } = _ref;
  return `
    padding: 0 6px 0 4px;
    letter-spacing: 0.2px;
    word-break: break-all;

    // Lodestar and Ursa Chips both use the same font styles
    font-size: var(--sds--chip--font-size, ${fontSize});
    padding-right: var(
        --sds--chip--label--padding-right,
        ${chipTheme.padding.right[chipSize](themeMode)}
    );
    padding-left: var(
        --sds--chip--label--padding-left,
        ${chipTheme.padding.left[chipSize](themeMode)}
    );
    font-weight: var(--sds--chip--label--weight, ${fontWeight});
    line-height: var(--sds--chip--label--line-height, ${lineHeight});
`;
});
//# sourceMappingURL=ChipLabelStyled.js.map